import { render, staticRenderFns } from "./SmsTemplateRouteV2Panel.vue?vue&type=template&id=5ae6bf9a&scoped=true"
import script from "./SmsTemplateRouteV2Panel.vue?vue&type=script&lang=js"
export * from "./SmsTemplateRouteV2Panel.vue?vue&type=script&lang=js"
import style0 from "./SmsTemplateRouteV2Panel.vue?vue&type=style&index=0&id=5ae6bf9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ae6bf9a",
  null
  
)

export default component.exports